import { permissionsByEntity, useCheckPermissions } from '@cmg/auth';
import { useCallback, useMemo } from 'react';

import type { CRMManagementRouteName } from '../CRMManagementDomainNav.model';

type UsePermissionedCRMManagementRoutesResult = Readonly<{
  readonly canAccessRoute: (route?: CRMManagementRouteName) => boolean;
}>;

export function usePermissionedCRMManagementRoutes(): UsePermissionedCRMManagementRoutesResult {
  const canManageFullCRM = useCheckPermissions([permissionsByEntity.CRM.FULL]);
  const canManageFullGlobalCrm = useCheckPermissions([permissionsByEntity.GlobalCrm.FULL]);

  const permissionedRoutes = useMemo(() => {
    const routes: CRMManagementRouteName[] = [];

    if (canManageFullCRM) {
      routes.push('customerCrmInvestorFirms', 'customerCrmSalesCoverage', 'customerCrmFilesUpload');
    }

    if (canManageFullGlobalCrm) {
      routes.push('sysAdminCrmInvestorFirms', 'sysAdminCrmSalesCoverage', 'sysAdminCrmFilesUpload');
    }

    return routes;
  }, [canManageFullCRM, canManageFullGlobalCrm]);

  const canAccessRoute = useCallback(
    (routeName?: CRMManagementRouteName) => {
      return routeName ? permissionedRoutes.includes(routeName) : false;
    },
    [permissionedRoutes]
  );

  return { canAccessRoute };
}
